// extracted by mini-css-extract-plugin
export default {"icon_container":"xyeNyr7gSJjrx3otDdnDkg==","description":"nX7Rd+WuO452M+ggkFB-RA==","ellipsis_header":"uTtLoD1hXuBDpj8TGz74JA=="};